import React, { memo } from "react"

const ArrowLeft = () => (
	<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle cx="16" cy="16" r="15" fill="#202028" stroke="#484A56" strokeWidth="2" />
	</svg>
)

export default memo(ArrowLeft)
